<span translate>reset <i class="icon-reload"></i></span>
